import {HttpClient, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {environment} from "@env/environment";
import {RetailerPipeline} from "@features/leads/pipeline/pipeline.model";
import {GenericService} from "@ui-kit/framework/common/generic.service";
import {Observable} from "rxjs";
import {GenericChart} from "src/app/shared/model/generic-chart.interface";
import {GroupedRetailerPipeline} from "../retailers/retailers.model";

@Injectable({
  providedIn: 'root'
})
export class PipelineService extends GenericService<RetailerPipeline> {
  constructor(http: HttpClient) {
    super(http, environment.apiRetailersHost + '/console/offering/district/pipeline/retailer-pipeline');
  }

  getChartData(params: {name: string, val: any}[]): Observable<GenericChart> {
    let requestParams = new HttpParams();

    if (params) {
      params.filter(f => f.val !== null).forEach(ea => {requestParams = requestParams.append(ea.name, ea.val)});
    }
    return this.http.get<GenericChart>(this.getBaseUrl + '/industries-chart', {params: requestParams});
  }

  get getBaseUrl() {
    return environment.apiRetailersHost + `/console/offering/district/pipeline/retailer-pipeline`;
  }

  loadQualifiedGroupedApplicants(page: { size: string; page: string; sort: string }, params: any[]): Observable<GroupedRetailerPipeline> {
    let requestParams = new HttpParams()
      .set('sort', page.sort)
      .set('size', page.size)
      .set('page', page.page);

    if (params) {
      params.filter(f => f.val !== null).forEach(ea => {
        requestParams = requestParams.append(ea.name, ea.val)
      });
    }
    return this.http.get<GroupedRetailerPipeline>(`${this.getBaseUrl}/qualified-applicants/grouped`, {params: requestParams})
  }
}
